 /* istanbul ignore file */
import { connect } from 'react-redux';
import IssueConfigView from './IssueConfigView';
import { loadIssueConfig, isAttachmentAvailable, changeDescriptionTitle, changeIssueTitle,
    changeIntroductionText, changeScreenTitle } from '../actions/IssueConfigActions';

const mapStateToProps = (state, ownProps) => {
    const { issueConfig } = state.issueConfig;
    
    return {
        issueConfig,
        store: ownProps.store
    };
}

const mapDispatchToProps = dispatch => {
    return {
        loadIssueConfig: ( customFields, synchCustomFields, collectorId, cardType ) => {
            dispatch( loadIssueConfig( customFields, synchCustomFields, collectorId, cardType ) )
        },
        isAttachmentAvailable: isAvailable => {
            dispatch(isAttachmentAvailable(isAvailable))
        },
        changeDescriptionTitle : descTitle => {
            dispatch(changeDescriptionTitle(descTitle))
        },
        changeScreenTitle : screenTitle => {
            dispatch(changeScreenTitle(screenTitle))
        },
        changeIntroductionText : introText => {
            dispatch(changeIntroductionText(introText))
        },
        changeIssueTitle : issueTitle => {
            dispatch(changeIssueTitle(issueTitle))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueConfigView);